/**
 * Portal dashboard chart palette (light mode — the portals are light-only).
 *
 * Categorical slots are a FIXED order, never cycled: assign series to slots by
 * entity, and fold a 5th+ series into "Other". Order was validated with the
 * dataviz palette validator against the white card surface:
 *   worst adjacent CVD ΔE 16.6 (target ≥ 12) — PASS.
 *   Slot 1 (emerald) is 2.82:1 vs white → relief rule: charts always ship a
 *   legend (≥ 2 series), tooltips, and the table view alongside.
 */
/** Fixed categorical order: emerald (money-in / brand), orange (money-out / brand), blue, violet. */
export const CHART_SERIES_COLORS = ['#1baf7a', '#eb6834', '#2a78d6', '#4a3aa7'];
export const CHART_INK = {
    /** Axis tick labels / muted ink */
    muted: '#898781',
    /** Hairline gridlines */
    grid: '#e1e0d9',
    /** Baseline / axis line */
    baseline: '#c3c2b7',
    /** Primary text */
    primary: '#0b0b0b',
};
export function seriesColor(index, explicit) {
    if (explicit)
        return explicit;
    return CHART_SERIES_COLORS[index % CHART_SERIES_COLORS.length];
}
